/**
 * StepBlueprint — Wizard Step 3 (ONBOARDING_FLOW).
 *
 * Explainer + the WorkStreamTemplates starter-template gallery (Story 4).
 * Selecting a template seeds the blueprint; the user can also skip.
 */

import { WorkStreamTemplates, getTemplateById } from '../WorkStreamTemplates';

interface StepBlueprintProps {
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function StepBlueprint({ selectedId, onSelect }: StepBlueprintProps) {
  const selected = getTemplateById(selectedId);
  return (
    <div>
      <span className="block text-sm font-medium text-text">First blueprint</span>
      <p className="mt-1 text-xs text-muted leading-relaxed">
        Start from a real example Carrie runs today, or skip to build from
        scratch. You can edit every step after creation.
      </p>
      <WorkStreamTemplates
        selectedId={selectedId}
        onSelect={onSelect}
        className="mt-3 grid grid-cols-1 gap-2"
      />
      {selected ? (
        <p className="mt-2 text-xs text-primary-700">
          Seeded from “{selected.name}” — {selected.source}.
        </p>
      ) : (
        <p className="mt-2 text-xs text-subtle">No template selected — you'll get a blank blueprint.</p>
      )}
    </div>
  );
}
